import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Taksim Koltuk Yıkama", path: "/beyoglu/taksim-koltuk-yikama" },
  { label: "Taksim Battaniye Yıkama", path: "/beyoglu/taksim-battaniye-yikama" },
  { label: "Cihangir Koltuk Yıkama", path: "/beyoglu/cihangir-koltuk-yikama" },
  { label: "Cihangir Yorgan Yıkama", path: "/beyoglu/cihangir-yorgan-yikama" },
  { label: "Galata Koltuk Yıkama", path: "/beyoglu/galata-koltuk-yikama" },
  { label: "Galata Perde Yıkama", path: "/beyoglu/galata-perde-yikama" },
  { label: "Kasımpaşa Koltuk Yıkama", path: "/beyoglu/kasimpasa-koltuk-yikama" },
  { label: "Kasımpaşa Yerinde Yıkama", path: "/beyoglu/kasimpasa-yerinde-yikama" },
  { label: "Şişhane Koltuk Yıkama", path: "/beyoglu/sishane-koltuk-yikama" },
  { label: "Şişhane Kuru Temizleme", path: "/beyoglu/sishane-kuru-temizleme" },
  { label: "Beyoğlu Merkez Koltuk Yıkama", path: "/beyoglu/merkez-koltuk-yikama" }
];

const BeyogluServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          BEYOĞLU HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default BeyogluServiceArea;
